var __fast_options = __fast_options || {};
__fast_options.with_product_attributes = true;
__fast_options.bring_product_pdp_images = true;

__fast_options.parseAcProductTitle = function(title, productData) {
  const attributes = productData?.att || [];

  const shortTitleAttribute = attributes.find(
    (attr) => attr[0] === "Toms.product display name"
  );

  if (
    shortTitleAttribute &&
    Array.isArray(shortTitleAttribute[1]) &&
    shortTitleAttribute[1][0]
  ) {
    return shortTitleAttribute[1][0];
  }

  // fallback to the original title if Toms.product display name does not exist
  return title;
};

__fast_options.parseProductTitle = function(title, productData) {
  const attributes = productData?.attributes || [];

  const shortTitleAttribute = attributes.find(
    (attr) => attr[0] === "Toms.product display name"
  );

  if (
    shortTitleAttribute &&
    Array.isArray(shortTitleAttribute[1]) &&
    shortTitleAttribute[1][0]
  ) {
    return shortTitleAttribute[1][0];
  }

  // fallback to the original title if Toms.product display name does not exist
  return title;
};

__fast_options.parseProductPrice = function(
    formattedPrice,
    comparePrice,
    productData,
    altProductData
) {
    return formattedPrice.replace(/\.00\b/g, "");
};

__fast_options.parseComparePrice = function(
    formattedCompare,
    productData,
    altProductData
) {
    return formattedCompare.replace(/\.00\b/g, "");
};


function getProductElements(element) {
    return [...element.querySelectorAll(`.fs-results-product-card`)];
}

/* ---------------------------------------------------------------------------
 * Badge meta
 *
 * Two independent systems want the top-left corner of the card:
 *
 *   1. `Cql.badge` - an indexed product attribute, one evergreen badge per
 *      product ("New", "Best Seller", "Polarized", ...).
 *   2. Fast Simon **merchandising** badges - configured in the dashboard under
 *      Merchandising -> Badges, date-boxed, and delivered per product as
 *      `productTextBadges` / `productBadges`. Fast Simon renders those itself
 *      as `.text-badge` inside `.fs-badges-wrapper`.
 *
 * A merchandising badge is a deliberate, dated promo, so when one is live for a
 * product it *overrides* the CQL badge rather than stacking next to it - the
 * card only ever shows one promo badge plus the review score.
 *
 * `icons` maps a badge tag or label to an SVG basename under
 * `window.badgeAssetsPath` (theme assets). Lookup order is: raw dashboard tag ->
 * slugified tag -> slugified label -> the slugified label as-is (so
 * "Best Seller" still resolves to best-seller.svg with no entry needed).
 * An explicit `null` means "this badge has no artwork yet" - the badge renders
 * as text only and, importantly, we skip the fetch instead of 404-ing once per
 * card.
 *
 * `hidden` are labels that must never render at all.
 * `overrideTags` narrows which merchandising badges take over the CQL slot;
 * leave it empty to let any live merchandising badge win.
 *
 * Everything here is data - override it from the theme by setting
 * `window.fsBadgeMeta` before this file loads, no code change required.
 * ------------------------------------------------------------------------ */
const BADGE_META = Object.assign(
    {
        hidden: ["water-resistant"],

        overrideTags: [],

        icons: {
            // --- merchandising badge tags currently configured in the dashboard ---
            "coll_promo-flash-maryjanes": "flash-sale",
            "coll_promo-badge-aug-bogo": "sale",

            // --- labels whose slug does not match a file in assets/ ---
            "bogo": "sale",
            "bogo-50-off": "sale",

            // --- approved badge values with no artwork in assets/ yet ---
            // (listed explicitly so they render text-only instead of firing a
            //  404 fetch for every card that carries them)
            "vegan": null,
            "top-rated": null,
            "wide-width": null,
            "waterproof": null,
            "machine-washable": null,
            "selling-fast": null,
            "trending": null,
            "our-icon": null,
            "seasonal": null,
            "easy-on": null
        }
    },
    window.fsBadgeMeta || {}
);

function badgeSlug(value) {
    return String(value || "")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

/* Every badge asset except sale.svg ships with width/height but NO viewBox
   (new.svg is 14x14, best-seller/flash-sale/exclusive/polarized are 15x14, ...).
   Without a viewBox an SVG has no internal coordinate system to map onto its
   box, so sizing it in CSS does not scale the artwork - it crops it. The 11px
   mobile badge icon was showing the top-left corner of a ~13.6x13.2 drawing,
   which is why icons looked off-centre and cut off. Deriving the viewBox from
   the intrinsic width/height restores proper scaling, and leaves any asset that
   already declares one untouched. */
function ensureSvgViewBox(markup) {
    return markup.replace(/<svg\b[^>]*>/i, (openTag) => {
        if (/\sviewBox\s*=/i.test(openTag)) return openTag;

        const width = openTag.match(/\swidth\s*=\s*["']?([\d.]+)/i);
        const height = openTag.match(/\sheight\s*=\s*["']?([\d.]+)/i);
        if (!width || !height) return openTag;

        return openTag.replace(/^<svg\b/i, `<svg viewBox="0 0 ${width[1]} ${height[1]}"`);
    });
}

// One in-flight request per icon instead of one per product card.
const badgeIconCache = new Map();

function loadBadgeIcon(iconName) {
    if (!iconName) return Promise.resolve("");

    if (!badgeIconCache.has(iconName)) {
        badgeIconCache.set(
            iconName,
            fetch(`${window.badgeAssetsPath}${iconName}.svg`)
                .then((response) => (response.ok ? response.text() : ""))
                .then(ensureSvgViewBox)
                .catch(() => "")
        );
    }

    return badgeIconCache.get(iconName);
}

// Returns the SVG basename for a badge, or null when it should render text-only.
function resolveBadgeIcon(label, tag) {
    const icons = BADGE_META.icons || {};

    for (const key of [tag, badgeSlug(tag), badgeSlug(label)]) {
        if (key && Object.prototype.hasOwnProperty.call(icons, key)) {
            return icons[key];
        }
    }

    return badgeSlug(label) || null;
}

const NewBadges = {
    set: (product, productElement) => {
        const imageWrapper = productElement.querySelector(".image-wrapper");
        if (!imageWrapper) return;

        // Fast Simon renders its own .fs-badges-wrapper; only build one when a
        // surface (e.g. recommendations) does not ship it.
        // Mark ours so consolidateBadgeWrappers() can tell the two apart: Fast
        // Simon's Svelte grid mounts its wrapper *after* this hook fires, so
        // "none exists yet" is not proof that none is coming.
        if (!productElement.querySelector(".fs-badges-wrapper")) {
            imageWrapper.insertAdjacentHTML(
                "afterBegin",
                `<div class="fs-badges-wrapper" data-fs-badge-own="1"></div>`
            );
        }

        const merchandisingBadges = NewBadges.merchandisingBadges(product);

        if (merchandisingBadges.length) {
            // The merchandising badge owns the slot - drop any CQL badge that a
            // previous pass left behind and give Fast Simon's own badge the
            // mapped icon.
            productElement
                .querySelectorAll(".fs_product_text_badge_flag.fs_cql_badge")
                .forEach((element) => element.remove());

            NewBadges.decorateMerchandisingBadges(productElement, merchandisingBadges);
        } else {
            const badgeValue = NewBadges.IsBadgeExists(product);

            if (badgeValue) {
                NewBadges.addLabel(
                    productElement,
                    badgeValue
                );
            }
        }

        // Add review score badge
        NewBadges.addReviewScoreLabel(product, productElement);

        // Last: fold every badge into a single wrapper and put them back into
        // normal flow, so they lay out as one row.
        NewBadges.consolidateBadgeWrappers(productElement);
        NewBadges.watchForLateBadgeWrapper(productElement);
    },

    // Fast Simon's Svelte card mounts its own .fs-badges-wrapper, and it can do
    // so after this hook has already run - at which point the card holds TWO
    // wrappers, both absolutely positioned at top:10px/left:10px, sitting on
    // top of each other. That is what makes the promo badge look like it is
    // "behind" the review-score badge: it is in the other box.
    //
    // Fold them into one. Fast Simon's own wrapper wins when present (it is the
    // one its stylesheet and any future FS feature targets); ours is emptied
    // and removed.
    consolidateBadgeWrappers: (productElement) => {
        const wrappers = [...productElement.querySelectorAll(".fs-badges-wrapper")];
        if (!wrappers.length) return null;

        const target =
            wrappers.find((wrapper) => !wrapper.dataset.fsBadgeOwn) || wrappers[0];

        for (const wrapper of wrappers) {
            if (wrapper === target) continue;

            // append, not prepend: `.fs-review-score-badge { order: 1 }` in
            // FSStyle.liquid is what actually keeps the star badge last.
            while (wrapper.firstChild) target.appendChild(wrapper.firstChild);

            // Only ever remove a wrapper we created - never a Fast Simon node.
            if (wrapper.dataset.fsBadgeOwn) wrapper.remove();
        }

        NewBadges.normaliseBadgeLayout(target);
        return target;
    },

    // One short-lived, scoped observer per card: it only watches direct
    // childList changes on .image-wrapper, and disconnects as soon as Fast
    // Simon's wrapper has shown up (or on the next lifecycle re-render, which
    // re-runs set() anyway). No polling, no document-wide scan.
    watchForLateBadgeWrapper: (productElement) => {
        const imageWrapper = productElement.querySelector(".image-wrapper");
        if (!imageWrapper || imageWrapper.dataset.fsBadgeWatch) return;
        imageWrapper.dataset.fsBadgeWatch = "1";

        const observer = new MutationObserver(() => {
            const target = NewBadges.consolidateBadgeWrappers(productElement);

            // Fast Simon's wrapper has arrived and everything now lives in it -
            // nothing left to wait for.
            if (target && !target.dataset.fsBadgeOwn) {
                observer.disconnect();
                delete imageWrapper.dataset.fsBadgeWatch;
            }
        });

        observer.observe(imageWrapper, { childList: true });

        // Hard stop so a card that never gets an FS wrapper does not keep an
        // observer alive for the life of the page.
        setTimeout(() => {
            observer.disconnect();
            delete imageWrapper.dataset.fsBadgeWatch;
        }, 5000);
    },

    // Fast Simon's dashboard badge style is written as an *inline* style on
    // .text-badge, and an inline (often !important) declaration beats anything
    // FSStyle.liquid can say. When that style carries position/top/left the
    // promo badge is taken out of the flex row and lands on the wrapper's own
    // origin - i.e. directly under the review-score badge. Strip only the
    // positioning properties; colours, radius and font from the dashboard are
    // left untouched.
    //
    // Idempotent: the wrapper re-runs on every Fast Simon lifecycle update
    // (load / filter / sort / paginate) and each node is only touched once.
    normaliseBadgeLayout: (wrapper) => {
        if (!wrapper) return;

        const POSITION_PROPS = [
            "position", "top", "right", "bottom", "left",
            "inset", "transform", "float", "margin",
            "margin-top", "margin-right", "margin-bottom", "margin-left",
            // Fast Simon's own offsets: its stylesheet reads these back as
            // `top: var(--text-badge-top)`, which is how the second promo badge
            // ends up at `top: 28px` instead of next to the first one.
            "--text-badge-top", "--text-badge-right",
            "--text-badge-bottom", "--text-badge-left"
        ];

        for (const node of wrapper.children) {
            if (node.dataset.fsBadgeFlow) continue;
            node.dataset.fsBadgeFlow = "1";

            for (const prop of POSITION_PROPS) {
                node.style.removeProperty(prop);
            }
        }
    },

    // Live merchandising badges for this product, already date-filtered server
    // side. `overrideTags` narrows it further when only some promos should win.
    merchandisingBadges: (product) => {
        const badges = [
            ...(product?.productTextBadges || []),
            ...(product?.productBadges || [])
        ];

        const only = BADGE_META.overrideTags || [];
        if (!only.length) return badges;

        return badges.filter(
            (badge) =>
                only.includes(badge?.tag) ||
                only.includes(badgeSlug(badge?.badgeText || badge?.displayName))
        );
    },

    // Fast Simon already printed the badge; all we add is the mapped icon.
    // `data-fs-badge-icon` doubles as the idempotency guard and as the hook the
    // stylesheet uses to drop its generic fallback icon.
    decorateMerchandisingBadges: (productElement, badges) => {
        const nodes = productElement.querySelectorAll(".text-badge");
        if (!nodes.length) return;

        const byLabel = new Map(
            badges.map((badge) => [
                badgeSlug(badge?.badgeText || badge?.displayName),
                badge
            ])
        );

        for (const node of nodes) {
            if (node.dataset.fsBadgeIcon) continue;

            const text = node.textContent.trim();
            const badge = byLabel.get(badgeSlug(text)) || badges[0];
            const iconName = resolveBadgeIcon(
                badge?.badgeText || badge?.displayName || text,
                badge?.tag
            );

            if (!iconName) continue;

            loadBadgeIcon(iconName).then((svg) => {
                if (!svg || node.dataset.fsBadgeIcon) return;
                node.dataset.fsBadgeIcon = iconName;
                node.insertAdjacentHTML("afterbegin", svg);
            });
        }
    },

    addLabel: (productElement, badgeValue) => {
        if ((BADGE_META.hidden || []).includes(badgeSlug(badgeValue))) {
            return;
        }

        if (!productElement.querySelector(".fs-badges-wrapper")) return;

        // Only ever replace the CQL badge - the previous version removed the
        // first `.fs_product_text_badge_flag` it found, which could be the
        // review-score badge.
        if (productElement.querySelector(".fs_cql_badge")) return;

        const label = qsEscape(badgeValue);

        const insert = (svgContent) => {
            // The icon fetch is async, so re-check before writing - and resolve
            // the wrapper *now*: consolidateBadgeWrappers() may have folded and
            // removed the one that existed when this call started, which would
            // otherwise write the badge into a detached node.
            if (productElement.querySelector(".fs_cql_badge")) return;

            const wrapper = NewBadges.consolidateBadgeWrappers(productElement);
            if (!wrapper) return;

            wrapper.insertAdjacentHTML(
                "afterBegin",
                `
                <span class="fs_product_text_badge_flag fs_cql_badge">
                    ${svgContent}
                    <span>${label}</span>
                </span>
            `
            );
        };

        const iconName = resolveBadgeIcon(badgeValue, null);

        if (!iconName) {
            insert("");
            return;
        }

        loadBadgeIcon(iconName).then(insert);
    },

    addReviewScoreLabel: (product, productElement) => {
        // set() can run more than once per card (Fast Simon re-renders on
        // filter / sort / paginate) - never stack a second star badge.
        if (productElement.querySelector(".fs-review-score-badge")) return;

        const reviewScore = product?.reviewScore;

        // No value → do nothing
        if (
            reviewScore === null ||
            reviewScore === undefined ||
            reviewScore === ""
        ) {
            return;
        }

        const score = Number(reviewScore);

        // Invalid value → do nothing
        if (Number.isNaN(score)) {
            return;
        }

        // Convert 100 → 5, 92 → 4.6, etc.
        const rating = score / 20;
        
        // Show only 4.0 and above rating.
        if(rating < 4.0) return;

        // viewBox is required, not decorative: without it the mobile CSS that
        // sizes this to 11px crops the star instead of scaling it.
        const starSVG = `
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.54.578a.5.5 0 0 1 .92 0l1.565 3.669a.5.5 0 0 0 .412.301l3.93.38a.5.5 0 0 1 .286.87l-2.971 2.667a.5.5 0 0 0-.155.48l.86 3.923a.5.5 0 0 1-.745.536l-3.385-2.031a.5.5 0 0 0-.514 0l-3.384 2.03a.5.5 0 0 1-.746-.535l.86-3.924a.5.5 0 0 0-.155-.479L.347 5.8a.5.5 0 0 1 .286-.87l3.93-.38a.5.5 0 0 0 .412-.302L6.54.578z" fill="#2A2A3F"></path>
            </svg>
        `;

        const badgeHTML = `
            <span class="fs_product_text_badge_flag fs-review-score-badge">
                ${starSVG}
                <span>${rating}</span>
            </span>
        `;

        productElement.querySelector(".fs-badges-wrapper")
            ?.insertAdjacentHTML("afterBegin", badgeHTML);
    },

    IsBadgeExists: (product) => {
        const attrs = product?.attributes || [];
        const displayNameEntry = attrs.find(
            ([key]) => key === "Cql.badge"
        );

        return displayNameEntry?.[1]?.[0] || null;
    }
};

/* ---------------------------------------------------------------------------
 * Card normalising - removes the "$26.00 -> $26" / "USD" / long-title flash
 *
 * `parseProductPrice` / `parseProductTitle` above only run inside Fast Simon's
 * *client* renderer. The first grid a shopper sees comes from the SSR service
 * (snippets/isp-ssr-preload.liquid preloads it and Fast Simon injects the HTML
 * client-side), and that markup never goes through those callbacks.
 *
 * This file is loaded with `defer`, so it cannot fix that itself: measured on
 * this store the SSR grid paints at ~2240ms and this script does not execute
 * until ~2836ms. The normaliser therefore lives in an inline <script> in
 * layout/theme.liquid, placed above the Fast Simon init and preload tags so it
 * is installed before there is anything to inject. See the comment block there.
 *
 * Everything below just *uses* that normaliser, so there is one copy of the
 * logic. If that block is missing, these calls no-op and the grid hook's own
 * work still happens - late, with the flash back, i.e. the old behaviour.
 * ------------------------------------------------------------------------ */

function normalisePriceMarkup(root) {
    window.fsPrePaint?.normalise(root);
}

/* ---------------------------------------------------------------------------
 * Quick Shop - Size (+ Width) picker
 *
 * Fast Simon flattens every variant into a single list of sizes, so a product
 * carrying both a Size and a Width option renders duplicated sizes
 * with no indication of which width they belong to.        
 *
 * These helpers replace that list with the same picker the theme renders on the
 * native search page: optional Width tabs, a full size grid where unavailable
 * sizes are struck through, and an explicit Add to cart button.
 *
 * Everything comes from the `vra` variant rows. This relies on "Enable showing
 * sold out variants" being on in the Fast Simon dashboard - without it `vra`
 * only carries sellable variants and sold-out sizes go missing from the grid
 * instead of appearing struck through.
 * ------------------------------------------------------------------------ */

const QS_RESERVED_VRA_KEYS = new Set([
    "v_id",
    "barcode",
    "price",
    "compare at price",
    "product-sku",
    "sellable",
    "imgs"
]);

// Products with a single option get one unnamed width bucket, which keeps the
// rest of the picker (and the Add to cart button) identical for both cases.
const QS_NO_WIDTH = "";

/* Quick Shop is desktop-only. On a phone the card is far too small for the size
   grid and the plus button competes with the product link for the same tap, so
   the trigger is not built at all - which also saves the per-card
   MutationObserver setupQuickShopOverlay() would otherwise attach.
   519px matches the breakpoint the rest of the Fast Simon CSS in
   snippets/FSStyle.liquid uses; that stylesheet also hides the trigger, which
   covers a shopper who resizes across the breakpoint after the grid rendered. */
/* Width alone was not enough: it missed tablets and large phones in landscape,
   and `fast-simon-upsell.js` calls setupQuickShopOverlay() for the
   recommendation carousels too, which sit outside `.fs-results-product-card`.
   The trigger is `opacity: 0` until `:hover`, and a touch device has no hover -
   tapping only produces a sticky emulated hover - so a pointer query is the
   condition that actually describes when this control cannot work. */
const QS_DISABLED_QUERIES = [
    "(max-width: 519px)",
    "(hover: none)",
    "(pointer: coarse)"
];

function isQuickShopDisabled() {
    if (!window.matchMedia) return false;
    return QS_DISABLED_QUERIES.some((query) => window.matchMedia(query).matches);
}

function qsEscape(value) {
    return String(value).replace(/[&<>"']/g, (character) => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    })[character]);
}

function findVraKey(row, matcher, exclude) {
    return Object.keys(row).find(
        (key) =>
            key !== exclude &&
            !QS_RESERVED_VRA_KEYS.has(key.toLowerCase()) &&
            matcher.test(key)
    );
}




// Builds { widths, sizes, map } from the `vra` variant rows. `map[width][size]`
// carries the variant id and whether it can be bought.
function matrixFromVra(product) {
    let rows = [];

    if (Array.isArray(product?.vra)) {
        // Existing VRA structure
        rows = product.vra;
    } else if (Array.isArray(product?.variants)) {
        // Normalize product.variants into the VRA structure
        rows = product.variants.map((variant) => {
            const attributes = variant.attributes || {};

            const sellableKey = Object.keys(attributes).find(
                (key) => key.toLowerCase() === "sellable"
            );

            return {
                ...attributes,
                v_id: variant.id,
                sellable: sellableKey
                    ? attributes[sellableKey]
                    : true
            };
        });
    }

    if (!rows.length) return null;

    const sample = rows[0];

    const widthKey = findVraKey(sample, /width/i);

    // Size is named per department ("women's size", "men's size", ...)
    const sizeKey =
        findVraKey(sample, /size/i, widthKey) ||
        Object.keys(sample).find(
            (key) =>
                key !== widthKey &&
                !QS_RESERVED_VRA_KEYS.has(key.toLowerCase())
        );

    if (!sizeKey) return null;

    const widths = [];
    const sizes = [];
    const map = {};

    for (const row of rows) {
        const width = widthKey
            ? row[widthKey]
            : QS_NO_WIDTH;

        const size = row[sizeKey];

        if (width == null || !size) continue;

        if (!map[width]) {
            widths.push(width);
            map[width] = {};
        }

        if (!sizes.includes(size)) {
            sizes.push(size);
        }

        map[width][size] = {
            id: row.v_id,
            available: row.sellable !== false
        };
    }

    if (!widths.length || !sizes.length) return null;

    // TOMS sizes are numeric - sort them
    if (
        sizes.every((size) =>
            Number.isFinite(parseFloat(size))
        )
    ) {
        sizes.sort(
            (a, b) => parseFloat(a) - parseFloat(b)
        );
    }

    return {
        widths,
        sizes,
        map
    };
}

function buildQuickShopPicker(optionsWrapper, product, closeOverlay) {
    if (optionsWrapper.dataset.fsQsBuilt === "true") return;

    const matrix = matrixFromVra(product);
    if (!matrix) return;

    optionsWrapper.dataset.fsQsBuilt = "true";
    optionsWrapper.classList.add("fs-qs-on");

    const panel = document.createElement("div");
    panel.className = "fs-qs-panel";
    panel.innerHTML = `
        <div class="fs-qs-widths" role="radiogroup" aria-label="Width"></div>
        <div class="fs-qs-sizes" role="radiogroup" aria-label="Size"></div>
        <button type="button" class="fs-qs-add">Add to cart</button>
        <span class="fs-qs-status" aria-live="polite"></span>
    `;
    optionsWrapper.appendChild(panel);

    const widthRow = panel.querySelector(".fs-qs-widths");
    const sizeRow = panel.querySelector(".fs-qs-sizes");
    const addButton = panel.querySelector(".fs-qs-add");
    const statusMessage = panel.querySelector(".fs-qs-status");

    let selectedWidth = matrix.widths[0];
    let selectedSize = null;

    const sizeButtons = () => [...sizeRow.querySelectorAll(".fs-qs-size")];

    function currentVariant() {
        return selectedSize ? matrix.map[selectedWidth]?.[selectedSize] : null;
    }

    function syncAddButton() {
        const variant = currentVariant();

        if (variant?.available) {
            addButton.disabled = false;
            addButton.textContent = "Add to cart";
            return;
        }

        addButton.disabled = true;
        addButton.textContent = sizeButtons().some((button) => !button.disabled)
            ? "Select a size"
            : "Sold out";
    }

    function selectSize(size) {
        const variant = size ? matrix.map[selectedWidth]?.[size] : null;
        if (size && !variant?.available) return;

        selectedSize = variant ? size : null;

        for (const button of sizeButtons()) {
            const isSelected = Boolean(selectedSize) && button.dataset.size === selectedSize;
            button.classList.toggle("is-selected", isSelected);
            button.setAttribute("aria-checked", String(isSelected));
        }

        syncAddButton();
    }

    function selectWidth(width) {
        if (!matrix.map[width]) return;
        selectedWidth = width;

        for (const button of widthRow.querySelectorAll(".fs-qs-width")) {
            const isSelected = button.dataset.width === width;
            button.classList.toggle("is-selected", isSelected);
            button.setAttribute("aria-checked", String(isSelected));
        }

        const previousSize = selectedSize;
        let firstAvailable = null;

        for (const button of sizeButtons()) {
            const variant = matrix.map[width][button.dataset.size];
            const available = Boolean(variant?.available);

            button.disabled = !available;
            button.classList.toggle("is-unavailable", !available);
            button.setAttribute("aria-disabled", String(!available));

            if (variant) {
                button.dataset.variantId = variant.id;
            } else {
                delete button.dataset.variantId;
            }

            if (available && !firstAvailable) firstAvailable = button.dataset.size;
        }

        // Keep the shopper's size when the new width still carries it.
        const keepSize = matrix.map[width][previousSize]?.available ? previousSize : firstAvailable;
        selectedSize = null;
        selectSize(keepSize);
    }

    // Click handlers are delegated onto the two rows rather than bound per
    // button, so the markup can be written in one pass.
    function renderRows() {
        widthRow.innerHTML =
            matrix.widths.length > 1
                ? matrix.widths
                      .map(
                          (width) => `
                <button type="button" class="fs-qs-width" role="radio" aria-checked="false"
                        data-width="${qsEscape(width)}"><span>${qsEscape(width)}</span></button>`
                      )
                      .join("")
                : "";

        sizeRow.innerHTML = matrix.sizes
            .map(
                (size) => `
                <button type="button" class="fs-qs-size" role="radio" aria-checked="false"
                        data-size="${qsEscape(size)}">${qsEscape(size)}</button>`
            )
            .join("");
    }

    widthRow.addEventListener("click", (event) => {
        const button = event.target.closest(".fs-qs-width");
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        selectWidth(button.dataset.width);
    });

    sizeRow.addEventListener("click", (event) => {
        const button = event.target.closest(".fs-qs-size");
        if (!button || button.disabled) return;
        event.preventDefault();
        event.stopPropagation();
        selectSize(button.dataset.size);
    });

    addButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variant = currentVariant();
        if (!variant?.available || addButton.dataset.busy === "true") return;

        addButton.dataset.busy = "true";
        addButton.disabled = true;
        addButton.textContent = "Adding...";

        const finish = (message, keepOpen) => {
            delete addButton.dataset.busy;
            statusMessage.textContent = message;
            syncAddButton();
            if (!keepOpen) closeOverlay();
        };

        // Fast Simon still renders one (hidden) option per sellable variant and
        // owns the add-to-cart request plus its own reporting, so proxy the click
        // instead of duplicating it. syncThemeCartOnFastSimonAdd() takes care of
        // refreshing the theme's cart UI afterwards.
        const fsOption = optionsWrapper.querySelector(
            `.options .option[data-variant-id="${variant.id}"]`
        );

        if (fsOption) {
            fsOption.click();
            window.setTimeout(() => finish("Added to cart"), 600);
            return;
        }

        // Fallback for the rare case Fast Simon did not render that option.
        fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        })
            .then((response) => (response.ok ? response.json() : Promise.reject(response)))
            .then(() => {
                notifyThemeCartUpdated(variant.id);
                finish("Added to cart");
            })
            .catch(() => finish("Could not add to cart. Please try again.", true));
    });

    renderRows();
    selectWidth(selectedWidth);
}

/* ---------------------------------------------------------------------------
 * Fast Simon posts to /cart/add.js itself and then fires `cart:refresh` plus its
 * own `fs-custom-events-product-added-to-cart`. This theme's cart icon and cart
 * drawer only listen for `cart:update`, so without this bridge the item is in
 * the cart server-side but nothing on the page updates until a reload.
 *
 * Mirrors assets/events.js `CartAddEvent`: event name `cart:update`, bubbling,
 * with a manually assigned `detail`. The class is *named* CartAddEvent because
 * assets/cart-icon.js branches on `event.constructor.name`.
 * ------------------------------------------------------------------------ */

const FsCartAddEvent = class CartAddEvent extends Event {
    constructor(resource, sourceId, data) {
        super("cart:update", { bubbles: true });
        this.detail = { resource, sourceId, data: { ...data } };
    }
};

function notifyThemeCartUpdated(variantId) {
    const cartDrawer = document.querySelector("cart-drawer-component");
    const hadAutoOpen = cartDrawer?.hasAttribute("auto-open");
    if (cartDrawer && !hadAutoOpen) cartDrawer.setAttribute("auto-open", "");

    document.dispatchEvent(
        // No `sections` payload, so cart-items-component re-renders itself from
        // the server - which is what we want after Fast Simon's own POST.
        new FsCartAddEvent({}, String(variantId || ""), {
            source: "add-to-cart-overlay",
            itemCount: 1,
            variantId: String(variantId || "")
        })
    );

    if (cartDrawer && !hadAutoOpen) {
        window.setTimeout(() => cartDrawer.removeAttribute("auto-open"), 500);
    }
}

let fsCartBridgeInstalled = false;
function syncThemeCartOnFastSimonAdd() {
    if (fsCartBridgeInstalled) return;
    fsCartBridgeInstalled = true;

    window.addEventListener("fs-custom-events-product-added-to-cart", (event) => {
        notifyThemeCartUpdated(event.detail?.selectedVariantID);
    });
}


function setupQuickShopOverlay(productElement, product) {
    /*
    const imageWrapper = productElement.querySelector(".img-container.image-wrapper");
    */
        if (isQuickShopDisabled()) return;

        const imageWrapper = productElement.querySelector(
            ".img-container.image-wrapper, .fs-recommendation-product-container .image-wrapper"
        );        

        if (!imageWrapper) return;

        if (!imageWrapper.querySelector(".add-to-cart-overlay-trigger")) {
            imageWrapper.insertAdjacentHTML(
                "beforeend",
                `
                <button
                    type="button"
                    class="add-to-cart-overlay-trigger"
                    aria-label="Add to cart"
                    data-open-overlay
                >
                    <svg class="sprite-icon" aria-label="Open modal for Quick Shop" width="18" height="18" title="Quick Shop">
                        <use xlink:href="#icon_plus"></use>
                    </svg>
                </button>
                `
            );
        }

        const openBtn = imageWrapper.querySelector(".add-to-cart-overlay-trigger");

        function bindOverlay() {
            const optionsWrapper = productElement.querySelector(".options-wrapper");
            if (!optionsWrapper || optionsWrapper.dataset.overlayBound === "true") return;

            optionsWrapper.dataset.overlayBound = "true";

            if (!optionsWrapper.querySelector(".close-overlay-button")) {
                optionsWrapper.insertAdjacentHTML(
                    "afterbegin",
                    `
                    <button
                        type="button"
                        class="close-overlay-button"
                        aria-label="Close"
                        data-close-overlay
                    >
                        <svg class="sprite-icon" aria-label="Close Quick Shop" width="19" height="18">
                            <use xlink:href="#icon_close"></use>
                        </svg>
                    </button>
                    `
                );
            }

            const closeBtn = optionsWrapper.querySelector(".close-overlay-button");

            // Fast Simon tears the wrapper down on mouse-leave and rebuilds it on
            // the next hover, so always re-query it instead of closing over a
            // detached node.
            const closeOverlay = () => {
                productElement.querySelector(".options-wrapper")?.classList.remove("is-open");
                imageWrapper.classList.remove("overlay-open");
            };

            // For the same reason, bind the (persistent) open button only once.
            if (openBtn.dataset.overlayBound !== "true") {
                openBtn.dataset.overlayBound = "true";
                openBtn.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    productElement.querySelector(".options-wrapper")?.classList.add("is-open");
                    imageWrapper.classList.add("overlay-open");
                });
            }

            closeBtn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                closeOverlay();
            });

            buildQuickShopPicker(optionsWrapper, product, closeOverlay);
        }

        bindOverlay();

        const observer = new MutationObserver(() => {
            // Fast Simon removes the wrapper on mouse-leave; drop the flag too so
            // the trigger button is not left permanently hidden by `.overlay-open`.
            if (!productElement.querySelector(".options-wrapper")) {
                imageWrapper.classList.remove("overlay-open");
            }
            bindOverlay();
        });

        observer.observe(productElement, {
            childList: true,
            subtree: true
        });
    }


function hooks() {

    window.SerpOptions.registerHook("serp-top-page", ({ element }) => {
        if (!element) return;

        const hideFiltersButton = element.querySelector(".hide-filters-button");

        if (!hideFiltersButton) return;

        // Prevent adding it multiple times
        if (hideFiltersButton.querySelector("svg")) return;

        const svgIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none">
            <g clip-path="url(#clip0_filters)">
                <path d="M9.35645 5.89258C8.22846 5.89258 7.29572 6.71881 7.11554 7.79688H0V8.54688H7.11554C7.29578 9.62446 8.22852 10.4507 9.35645 10.4507C10.4848 10.4507 11.4176 9.62446 11.5978 8.54688H13.5254V7.79688H11.5978C11.4176 6.71882 10.4849 5.89258 9.35645 5.89258ZM9.35645 9.70069C8.51368 9.70069 7.82764 9.01465 7.82764 8.17188C7.82764 7.32862 8.51368 6.64258 9.35645 6.64258C10.1997 6.64258 10.8857 7.32862 10.8857 8.17188C10.8857 9.01465 10.1997 9.70069 9.35645 9.70069Z" fill="currentColor"></path>
                <path d="M6.35858 1.90381C6.17834 0.82623 5.24554 0 4.11719 0C2.98926 0 2.05652 0.82623 1.87628 1.90381H0V2.65381H1.87628C2.05646 3.73187 2.9892 4.55811 4.11719 4.55811C5.24561 4.55811 6.17835 3.73188 6.35858 2.65381H13.5254V1.90381H6.35858ZM4.11719 3.80811C3.27442 3.80811 2.58838 3.12207 2.58838 2.27881C2.58838 1.43604 3.27442 0.75 4.11719 0.75C4.96045 0.75 5.64649 1.43604 5.64649 2.27881C5.64649 3.12207 4.96045 3.80811 4.11719 3.80811Z" fill="currentColor"></path>
            </g>
            <defs>
                <clipPath id="clip0_filters">
                <rect width="13.5254" height="10.4507" fill="white"></rect>
                </clipPath>
            </defs>
            </svg>
        `;

        hideFiltersButton.insertAdjacentHTML("beforeend", svgIcon);
    });

    
    window.SerpOptions.registerHook("serp-filters", ({ facets, element }) => {
        element.querySelectorAll(".fs-cur-name").forEach(el => { el.textContent = "$"; });
    });


    window.SerpOptions.registerHook("serp-product-grid", ({ products, element }) => {
        
        for (const productElement of getProductElements(element)) {
            const productID = productElement.dataset.productId;
            const data = products[productID];

            if (typeof data !== "undefined" && data !== null) {
                if (productElement.classList.contains("fs-product-processed")) {
                    continue;
                }

                productElement.classList.add("fs-product-processed");                

                // add available sizes
                setupQuickShopOverlay(productElement, data);

                // adding color count 
                const attrs = data?.attributes || [];                

                const groupBuilderEntry = attrs.find(
                    ([key]) => key === "Toms.product group builder list"
                );                                

                const groupBuilderList = Array.isArray(groupBuilderEntry?.[1]) ? groupBuilderEntry[1] : [];
                const extraColorsCount = groupBuilderList.length - 1;
                if (extraColorsCount > 0) {
                    const infoContainer = productElement.querySelector(".info-container");
                    const existingLabel = productElement.querySelector(".fs-extra-colors-label");

                    if (infoContainer && !existingLabel) {
                        infoContainer.insertAdjacentHTML(
                            "beforeend",
                            `<div class="fs-extra-colors-label">+${extraColorsCount} Color${extraColorsCount > 1 ? "s" : ""}</div>`
                        );
                    }
                }

                const displayColorEntry = attrs.find(
                    ([key]) => key === "Toms.product display color"
                );
                const displayColor = displayColorEntry?.[1]?.[0];
                if (displayColor) {
                    const titleElement = productElement.querySelector(
                        ".title-container, .fs-serp-product-title"
                    );

                    if (titleElement && !productElement.querySelector(".fs-product-display-color")) {
                        titleElement.insertAdjacentHTML(
                            "afterend",
                            `<div class="fs-product-display-color">In ${qsEscape(displayColor)}</div>`
                        );
                    }
                }



                // Compare price, ".00" and short title. The <head> normaliser
                // in layout/theme.liquid has normally done all of this before
                // paint; this is the idempotent catch-up for anything it did
                // not see (and the fallback if that block is missing).
                normalisePriceMarkup(productElement);


                // add badges - runs inline rather than on the old 2s timer: the
                // card, its .image-wrapper and Fast Simon's own
                // .fs-badges-wrapper all exist by the time this hook fires, and
                // the delay was what made badges pop in long after the grid.
                NewBadges.set(data, productElement);
            }
        }
    });

    
}

let fsHooksInitialised = false;
function initFsHooks() {
    if (fsHooksInitialised || !window.SerpOptions) return;
    fsHooksInitialised = true;
    syncThemeCartOnFastSimonAdd();
    hooks();
}

// Catch-up sweep for anything the <head> normaliser in layout/theme.liquid did
// not see. Idempotent, and a no-op when that block is present and already did
// the work.
normalisePriceMarkup(document.body);

window.addEventListener('fast-serp-ready', initFsHooks);
initFsHooks();

window.addEventListener('fs-custom-events-product-added-to-cart', (e) => {
    let cartIcon = document.querySelector(".cart-drawer .button");
    cartIcon?.click();
});